<section *ngIf="!loading" class="categories__page">
  <h1>Todas as categorias</h1>

  <div *ngFor="let categories of productsCategoryList" class="categories-container">
    <h3>{{ categories.label }}</h3>

    <div class="subcategories">
      <div nz-row [nzGutter]="16">
        <div *ngFor="let subcategories of categories.children" nz-col class="gutter-row" [nzSpan]="4">
          <div class="inner-box">
            <p (click)="onSelectCategory(subcategories, 'selected')">{{ subcategories.label }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="categories-container">
    <h3>Outras categorias</h3>

    <div class="subcategories">
      <div nz-row [nzGutter]="16">
        <div *ngFor="let subcategories of productsCustomCategoryList" nz-col class="gutter-row" [nzSpan]="4">
          <div class="inner-box">
            <p (click)="onSelectCategory(subcategories, 'selected')">{{ subcategories.label }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<app-loading *ngIf="loading"></app-loading>
